import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Youtube, Store } from 'lucide-react';

const Footer = () => (
  <footer style={{ background: '#1a1a2e', color: '#9ca3af', marginTop: 'auto' }}>
    <div className="container" style={{ paddingTop: '3rem', paddingBottom: '2rem' }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '2rem', marginBottom: '2rem' }}>
        {/* Brand */}
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
            <div style={{ width: 36, height: 36, background: 'linear-gradient(135deg, #f43397, #6c3fc5)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Store size={20} color="white" />
            </div>
            <span style={{ fontSize: 22, fontWeight: 800, color: 'white' }}>ENew Aura Solutions</span>
          </div>
          <p style={{ fontSize: 13, lineHeight: 1.7, marginBottom: 16 }}>India's largest online marketplace for fashion, home, electronics and more. Shop from millions of products.</p>
          <div style={{ display: 'flex', gap: 12 }}>
            {[Facebook, Instagram, Twitter, Youtube].map((Icon, i) => (
              <button key={i} style={{ width: 36, height: 36, borderRadius: 8, background: '#2d2d44', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', cursor: 'pointer', color: '#9ca3af', transition: 'all 0.2s' }}
                onMouseEnter={e => { e.currentTarget.style.background = '#f43397'; e.currentTarget.style.color = 'white'; }}
                onMouseLeave={e => { e.currentTarget.style.background = '#2d2d44'; e.currentTarget.style.color = '#9ca3af'; }}
              >
                <Icon size={16} />
              </button>
            ))}
          </div>
        </div>

        {/* Links */}
        {[
          { title: 'Shop', links: ['Women Ethnic', 'Women Western', 'Men', 'Kids', 'Electronics', 'Home & Kitchen'] },
          { title: 'Help', links: ['Track Order', 'Returns & Exchanges', 'FAQs', 'Contact Us', 'Shipping Policy'] },
          { title: 'Company', links: ['About Us', 'Careers', 'Sell on ENew Aura Solutions', 'Investor Relations', 'Privacy Policy', 'Terms of Service'] },
        ].map(section => (
          <div key={section.title}>
            <h4 style={{ color: 'white', fontWeight: 600, marginBottom: 14, fontSize: 15 }}>{section.title}</h4>
            <ul style={{ listStyle: 'none' }}>
              {section.links.map(link => (
                <li key={link} style={{ marginBottom: 8 }}>
                  <Link to="/" style={{ fontSize: 13, color: '#9ca3af', transition: 'color 0.2s' }}
                    onMouseEnter={e => e.currentTarget.style.color = '#f43397'}
                    onMouseLeave={e => e.currentTarget.style.color = '#9ca3af'}
                  >{link}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}

        {/* App download */}
        <div>
          <h4 style={{ color: 'white', fontWeight: 600, marginBottom: 14, fontSize: 15 }}>Download App</h4>
          <p style={{ fontSize: 13, marginBottom: 12 }}>Get extra ₹50 off on your first app order</p>
          {['App Store', 'Google Play'].map(store => (
            <button key={store} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 14px', background: '#2d2d44', borderRadius: 8, border: '1px solid #3d3d5a', marginBottom: 8, cursor: 'pointer', width: '100%', color: 'white', fontSize: 13, fontFamily: 'inherit' }}>
              📱 {store}
            </button>
          ))}
        </div>
      </div>

      <div style={{ borderTop: '1px solid #2d2d44', paddingTop: 20, display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
        <p style={{ fontSize: 13 }}>© 2026 ENew Aura Solutions.</p>
        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
          <span style={{ fontSize: 13 }}>🔒 Secure Payments</span>
          <span style={{ fontSize: 13 }}>📦 Free Returns</span>
          <span style={{ fontSize: 13 }}>⭐ 4.8/5 Rating</span>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
